import React, { Fragment } from "react";
import ReactSelect from "react-select";
import Firebase from "../../firebasehelper";
import {
  admin_types,
  sales_user_access,
  user_access,
} from "../../Constants/selections";
import "./index.css";

const userAccessImg = require("../../assets/media/profile/access.png");

class AddDemoUserModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
    this.state = {
      firstname: "",
      copied: false,
      created_user: null,
      userAccess: null,
      profile: null,
    };
  }

  componentDidMount() {
    const { brandData } = this.props;

    user_access[
      user_access.findIndex((access) => access.value === "Brandname employee")
    ] = {
      value: "Brandname employee",
      label: `Member - ${brandData.name} employee`,
    };
    user_access[
      user_access.findIndex((access) => access.value === "Friend of brandname")
    ] = {
      value: "Friend of brandname",
      label: `Member - Friend of ${brandData.name}`,
    };

    let profile = localStorage.getItem("profile");
    if (!profile) {
      const uid = localStorage.getItem("uid");
      Firebase.getAgencyData(uid, (res) => {
        this.setState({ profile: res });
      });
    } else {
      this.setState({ profile });
    }

    document.addEventListener("mousedown", this.onOutsideClick);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.onOutsideClick);
  }
  resetFormFields = () => {
    this.setState({
      firstname: "",
      copied: false,
      idCopied: false,
      created_user: null,
      userAccess: null,
    });
  };
  onChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  copyText = (e) => {
    navigator.clipboard.writeText(this.textArea.value);
    this.setState({ copied: true });
  };
  copyTextId = (e) => {
    navigator.clipboard.writeText(this.textAreaId.value);
    this.setState({ idCopied: true });
  };
  createLink = async () => {
    const { firstname, userAccess, profile } = this.state;
    const { brandData, onAdd } = this.props;
    const brandName = brandData.name;
    const uid = localStorage.getItem("uid");
    let newUser = {
      firstname,
      user_access: userAccess,
      userstatus: "Active",
    };
    if (
      profile &&
      ["Sales manager", "Sales rep", "Service manager", "Service rep"].includes(
        profile.type
      )
    ) {
      newUser.accountant = uid;
    }
    const user = await Firebase.addLightUser(brandName, newUser);
    this.setState({ created_user: user });
    onAdd({
      id: user.id,
      ...newUser,
    });
  };
  onOutsideClick = (e) => {
    if (!this.modalRef.current.contains(e.target)) {
      this.resetFormFields();
    }
  };
  render() {
    const { firstname, created_user, copied, idCopied, userAccess, profile } =
      this.state;
    const { hex, white } = this.props.brandData;

    let brandName = this.props.brandData.name;
    const { bespokeUrl } = this.props.brandData;
    let brand_name = brandName.replace(/\s/g, "");

    return (
      <div
        className="modal fade"
        id="add_demo_user"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content" ref={this.modalRef}>
            <div className="modal-header">
              <h5 className="modal-title">Create a light user</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.resetFormFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  id="signup-username"
                  name="firstname"
                  placeholder="First Name"
                  onChange={this.onChangeHandler}
                  value={firstname && firstname.replace(" ", "-")}
                />
                <div className="user-access-select">
                  <img src={userAccessImg} alt="icon" width="30px" />
                  <div style={{ width: "100%", marginLeft: "20px" }}>
                    <ReactSelect
                      value={
                        user_access.find(
                          (access) => access.value === userAccess
                        ) || null
                      }
                      onChange={(value) =>
                        this.setState({ userAccess: value.value })
                      }
                      options={user_access}
                    />
                  </div>
                </div>
              </div>
              {created_user && (
                <Fragment>
                  <div className="input-row-group mt-2 mb-2">
                    <h6>User link</h6>
                    <p>Copy your user link to share access with the user</p>
                  </div>
                  <div className="input-row-group">
                    <div className="form-group">
                      <input
                        type="text"
                        ref={(textArea) => (this.textArea = textArea)}
                        style={{ fontSize: 14 }}
                        className="form-control form-control-lg form-control-alt"
                        value={
                          bespokeUrl
                            ? `${bespokeUrl}?uid=${created_user.id}`
                            : `https://ecosystem.club/${brand_name}?uid=${created_user.id}`
                        }
                        disabled
                      />
                    </div>
                    {!copied && (
                      <button
                        type="button"
                        className="btn btn-sm btn-green"
                        onClick={this.copyText}
                      >
                        Copy to clipboard
                      </button>
                    )}
                    {copied && <p>Copied</p>}
                  </div>
                </Fragment>
              )}
              {created_user && (
                <Fragment>
                  <div className="input-row-group mb-2 mt-2">
                    <h6>User ID</h6>
                    <p>Copy your user ID to create a record in your CRM</p>
                  </div>
                  <div className="input-row-group">
                    <div className="form-group">
                      <input
                        type="text"
                        ref={(textArea) => (this.textAreaId = textArea)}
                        style={{ fontSize: 14 }}
                        className="form-control form-control-lg form-control-alt"
                        value={created_user.id}
                        disabled
                      />
                    </div>
                    {!idCopied && (
                      <button
                        type="button"
                        className="btn btn-sm btn-green"
                        onClick={this.copyTextId}
                      >
                        Copy to clipboard
                      </button>
                    )}
                    {idCopied && <p>Copied</p>}
                  </div>
                </Fragment>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-brand-hex btn-light"
                data-dismiss="modal"
                onClick={this.resetFormFields}
                style={{
                  boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.2)",
                  backgroundColor: "white",
                  color: "black",
                  "--hover-color": hex,
                  "--hover-text-color": white ? "white" : "black",
                }}
              >
                Close
              </button>
              {!created_user && (
                <button
                  type="button"
                  className="btn btn-green"
                  onClick={this.createLink}
                  disabled={!firstname || !userAccess}
                >
                  Create light user
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddDemoUserModal;



// WEBPACK FOOTER //
// ./src/components/AddDemoUserModal/index.js